import React from "react";
import REST from "go/requests/rest";
import _, {findLastKey} from "lodash";
import {connect} from "react-redux";
import {connectDynamic} from "go/components/dynamic/dynamicComponent";
export class UpdateEntityWrapper extends React.Component {
  handleSubmit = async (...args) => {

    const {token, getEntity, saveEntitySessionData, getAuthentication} = this.props;
    const entities = getEntity();
    let isAuthenticated;
    try {
        isAuthenticated = getAuthentication
        ? await getAuthentication(...args)
        : undefined;
    } catch (error) {
      console.error("Failed : ", error);
    }
    
    if (isAuthenticated || isAuthenticated === undefined) {
      const promises = _.map(entities, (entity) =>
        REST.dynamicData
          .updateEntity(token, entity.entity)
          .then(REST.handler.handleResponse)
          .then((savedEntity) => {
            // how do we know where to save each object back to in redux? Need to get datapaths
            if (saveEntitySessionData) {
              saveEntitySessionData(entity.entityDataPath, savedEntity);
            }
            return Promise.resolve();
          })
      );

      if (isAuthenticated === undefined) {
        return Promise.all(promises)
          .then((response) => {
            return this.props.handleSubmit(...args);
          })
          .catch((err) => {
            console.error("Failed to save entities on submission: ", err);
          });
      }
    }
  };

  render() {
    return this.props.children(this.handleSubmit);
  }
}

export const mapStateToProps = (state) => {
  return {
    token: _.get(state, "auth.token"),
  };
};

export const mapDispatchToProps = (dispatch) => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(connectDynamic(UpdateEntityWrapper));
